"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the string constants you can use as HTML attributes for the <tableau-ask-data> web component.
 * @ignore
 * @deprecated
 */
var AskDataAttributes;
(function (AskDataAttributes) {
    AskDataAttributes["Origin"] = "origin";
    AskDataAttributes["ShowEmbed"] = "show-embed";
    AskDataAttributes["ShowPin"] = "show-pin";
    AskDataAttributes["ShowSave"] = "show-save";
    AskDataAttributes["ShowShare"] = "show-share";
})(AskDataAttributes = exports.AskDataAttributes || (exports.AskDataAttributes = {}));
//# sourceMappingURL=AskDataInterfaces.js.map